module.exports = __webpack_public_path__ + "static/media/bgImage.79f2e0b3.jpg";